
export default function selectInput(theme) {

    return {
        MuiSelect: {
            styleOverrides: {
                select: {
                    display: 'block !important',
                    alignItems: 'center',
                    padding: '8px 12px',
                    paddingRight: '32px !important',
                    '& > .MuiBox-root, & > .MuiTypography-root': {
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: 'block',
                        width: '100%',
                    },
                },
            },
        },
        MuiMenu: {
            defaultProps: {
                disableScrollLock: true,
                autoFocus: false,
            },
            styleOverrides: {
                list: {
                    paddingTop: 0,
                    paddingBottom: 0,
                },
                paper: {
                    pointerEvents: 'auto',
                    maxHeight: 300,
                    width: 250,
                    borderRadius: '15px !important',
                    boxShadow: '0px 4px 20px rgba(0,0,0,0.1)',
                    border: '1px solid #e0e0e0',
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    '& .MuiCheckbox-root': {
                        padding: '4px', 
                    },
                    '& > .MuiBox-root, & > .MuiTypography-root': {
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: 'block',
                        width: '100%',
                    },
                    '&:hover': {
                        backgroundColor: `${theme.palette.primary[100]} !important`,
                    },
                    '&.Mui-selected': {
                        backgroundColor: '#D2E0FF',
                    },
                },
            },
        },
        MuiListItemText: {
            styleOverrides: {
                root: {
                    margin: 0,
                },
                primary: {
                    fontSize: '12px',
                    fontWeight: 400,
                },
                secondary: {
                    fontSize: '12px',
                },
            },
        },

        MuiPopover: {
            styleOverrides: {
                root: {
                    '& .MuiBackdrop-root': {
                        backgroundColor: 'transparent !important',
                        backdropFilter: 'none !important',
                        WebkitBackdropFilter: 'none !important',
                    },
                },
            },
        },
    }
}